/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Category_Order_NoteInputs */

const vi_shop_category_order_note = /** @type {(inputs: Shop_Category_Order_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thứ tự lấy theo vị trí kéo thả trong danh sách.`)
};

/**

* @param {Shop_Category_Order_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_category_order_note = /** @type {((inputs?: Shop_Category_Order_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Category_Order_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_category_order_note(inputs)
});